import React from "react";
import { RouterProvider } from "@tanstack/react-router";
import { ThemeProvider, createTheme } from "@mui/material";
import CssBaseline from "@mui/material/CssBaseline";
import { AuthProvider } from "./context/AuthContext";
import Navbar from "./components/Navbar";
import { router } from "./router.jsx";

const theme = createTheme({
  palette: {
    primary: {
      main: "#BF2924",
    },
    secondary: {
      main: "#666666",
    },
    background: {
      default: "#ffffff",
    },
  },
  typography: {
    fontFamily: "Inter, sans-serif",
    h1: {
      fontSize: "32px",
      fontWeight: 600,
      letterSpacing: "-0.01em",
    },
    h2: {
      fontSize: "24px",
      fontWeight: 600,
      letterSpacing: "-0.01em",
    },
    body1: {
      fontSize: "16px",
      lineHeight: 1.5,
    },
    button: {
      textTransform: "none",
    },
  },
  components: {
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          borderRadius: 8,
          padding: "10px 16px",
        },
      },
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <RouterProvider router={router} />
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
